import { ExportToCsv } from 'export-to-csv';
import { CSV_EXPORT_DEFAULTS } from './DataConstants';
import { floatToPercentageString } from './DataFormatterUtils';
import { nullSafeGetOrElse } from './DataAccessUtils';
import { COMPARISON_MODE, ComparisonState } from './AnalyticsComparisonUtils';

export type BreakdownExportRow = {
	fieldName: string;
	subTotal: number;
	percentageOfTotal?: number;
};

export type ExportBreakdownCsvOptions = {
	title: string;
	categoryColumnLabel: string;
	valueColumnLabel: string;
	currentRows: BreakdownExportRow[];
	comparisonRows?: BreakdownExportRow[];
	comparisonState?: ComparisonState | null;
	formatValue: (amount: number) => string | number;
};

export const exportBreakdownCsv = ({
	title,
	categoryColumnLabel,
	valueColumnLabel,
	currentRows,
	comparisonRows,
	comparisonState,
	formatValue,
}: ExportBreakdownCsvOptions) => {
	const hasComparison =
		comparisonState &&
		comparisonState.mode !== COMPARISON_MODE.NONE &&
		comparisonRows &&
		comparisonRows.length > 0;

	const baseHeaders = [categoryColumnLabel, valueColumnLabel, 'Percentage'];
	const headers = hasComparison ? [...baseHeaders, 'Historical Data'] : baseHeaders;

	const mapRow = (row: BreakdownExportRow, isHistorical: boolean) => {
		const base: Record<string, string | number> = {
			category: row.fieldName,
			value: formatValue(nullSafeGetOrElse('subTotal', row, 0)),
			percentage: floatToPercentageString(nullSafeGetOrElse('percentageOfTotal', row, 0) / 100),
		};
		if (hasComparison) {
			base.historicalData = isHistorical ? 'Yes' : 'No';
		}
		return base;
	};

	const previousRows = hasComparison ? comparisonRows.map((row) => mapRow(row, true)) : [];
	const currentExportRows = (currentRows || []).map((row) => mapRow(row, false));

	const csvExporter = new ExportToCsv({
		...CSV_EXPORT_DEFAULTS,
		filename: title,
		title,
		headers,
	});

	csvExporter.generateCsv([...previousRows, ...currentExportRows]);
};
